const s = {
  name: "VietnameseDong",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,10v2h2v2h-2v12h-2v-1c-0.8,0.6-1.9,1-3,1c-2.8,0-5-2.2-5-5s2.2-5,5-5c1.1,0,2.2,0.4,3,1v-3h-2v-2h2v-2H24
			z M22,21c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3C20.7,24,22,22.7,22,21z"/>
		<path class="st0" d="M14,28v2h10v-2H14z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as VietnameseDong
};
